export const styles = {
  permissionMessageBox: {
    marginBottom: 3,
  },
  permissionMessage: {
    marginBottom: 0.75,
  },
  roleChangeList: {
    padding: 0,
  },
  listItem: {
    display: 'list-item',
    listStyleType: 'disc',
    pl: 0,
    ml: 2,
  },
};
